import {useEffect, useState} from 'react'
import {useRaisedShadow} from '../../../../services/customHooks/useRaisedShadow'

import { useDragControls, useMotionValue } from "framer-motion";


const useAdminEditItem = () => {
    const [, setOnDrag] = useState(false)
    const controls = useDragControls()
    const y = useMotionValue(0)
    const boxShadow = useRaisedShadow(y)

    useEffect(()=>{
        let isActive = false;
        y.onChange((latest) => {
            const wasActive = isActive;
            if (latest !== 0) {
                isActive = true;
                if (isActive !== wasActive) {
                    setOnDrag(true)
                }
            } else {
                isActive = false;
                if (isActive !== wasActive) {
                    setOnDrag(false)
                }
            }
        });
    }, [y])

    return {controls, boxShadow, y}
}

export default useAdminEditItem